import React, { useState } from 'react'
import useFavurTranslation from 'hooks/useFavurTranslation'
import ActionButtons from 'redesign/components/organisms/action-buttons'
import BalanceModal from '../modals/balance-modal'
import type { AbsenceAcceptDetailsFooterProps } from './types'
import { getActionButtons } from './utils'

const AbsenceAcceptDetailsFooter: React.FC<AbsenceAcceptDetailsFooterProps> = ({ onSubmit, task }) => {
  const { t } = useFavurTranslation()
  const [open, setOpen] = useState(false)
  const buttons = getActionButtons({
    t,
    onSubmit,
    showBalance: () => setOpen(true),
  })

  return (
    <>
      <BalanceModal open={open} onClose={() => setOpen(false)} task={task} />
      <ActionButtons mainActions={buttons} />
    </>
  )
}

export default AbsenceAcceptDetailsFooter
